// Curated marine engine catalog: brand → list of { type, kw } models.
// kW values are nominal manufacturer ratings; users can override after auto-fill.
// Brands not listed here (or "Other" via custom entry) fall back to free-text
// type and manual kW — the picker degrades gracefully.

export const ENGINE_CATALOG = {
  "MAN": [
    { type: "i6-730", kw: 537 },
    { type: "i6-800", kw: 588 },
    { type: "V8-800", kw: 588 },
    { type: "V8-900", kw: 662 },
    { type: "V8-1000", kw: 735 },
    { type: "V8-1200", kw: 882 },
    { type: "V8-1300", kw: 956 },
    { type: "V12-1550", kw: 1140 },
    { type: "V12-1650", kw: 1213 },
    { type: "V12-1800", kw: 1324 },
    { type: "V12-1900", kw: 1397 },
    { type: "V12-2000", kw: 1471 },
  ],
  "MTU": [
    { type: "8V 2000 M72", kw: 720 },
    { type: "8V 2000 M84", kw: 800 },
    { type: "8V 2000 M94", kw: 954 },
    { type: "10V 2000 M86", kw: 1080 },
    { type: "10V 2000 M94", kw: 1193 },
    { type: "12V 2000 M84", kw: 1200 },
    { type: "12V 2000 M86", kw: 1380 },
    { type: "12V 2000 M94", kw: 1432 },
    { type: "16V 2000 M86", kw: 1622 },
    { type: "16V 2000 M96L", kw: 1939 },
    { type: "12V 4000 M73L", kw: 2240 },
    { type: "16V 4000 M93L", kw: 3200 },
  ],
  "Volvo Penta": [
    { type: "D6-440", kw: 324 },
    { type: "D11-510", kw: 375 },
    { type: "D13-700", kw: 515 },
    { type: "D13-800", kw: 588 },
    { type: "D13-900", kw: 662 },
    { type: "D13-1000", kw: 735 },
    { type: "IPS650", kw: 353 },
    { type: "IPS800", kw: 441 },
    { type: "IPS950", kw: 533 },
    { type: "IPS1050", kw: 588 },
    { type: "IPS1200", kw: 662 },
  ],
  "Caterpillar": [
    { type: "C7.1", kw: 373 },
    { type: "C9.3", kw: 533 },
    { type: "C12.9", kw: 746 },
    { type: "C18 ACERT", kw: 858 },
    { type: "C32 ACERT", kw: 1417 },
    { type: "C32B", kw: 1900 },
  ],
  "Cummins": [
    { type: "QSB6.7", kw: 358 },
    { type: "QSC8.3", kw: 410 },
    { type: "QSL9", kw: 447 },
    { type: "QSM11", kw: 522 },
    { type: "QSX15", kw: 522 },
    { type: "QSK19", kw: 597 },
    { type: "QSK38", kw: 1100 },
    { type: "QSK60", kw: 1865 },
  ],
  "Yanmar": [
    { type: "4LV195", kw: 143 },
    { type: "4LV230", kw: 170 },
    { type: "4LV250", kw: 184 },
    { type: "6LY3-400", kw: 294 },
    { type: "6LY3-440", kw: 324 },
    { type: "6LY400", kw: 294 },
    { type: "8LV-320", kw: 235 },
    { type: "8LV-370", kw: 272 },
  ],
  "John Deere": [
    { type: "4045 PowerTech", kw: 168 },
    { type: "6068 PowerTech", kw: 261 },
    { type: "6090 PowerTech", kw: 410 },
    { type: "6135 PowerTech", kw: 559 },
  ],
  "Scania": [
    { type: "DI13 071M", kw: 478 },
    { type: "DI13 074M", kw: 552 },
    { type: "DI13 080M", kw: 662 },
    { type: "DI16 070M", kw: 736 },
    { type: "DI16 080M", kw: 920 },
  ],
  "Yamaha": [
    { type: "F100", kw: 73 },
    { type: "F150", kw: 110 },
    { type: "F200", kw: 147 },
    { type: "F250", kw: 184 },
    { type: "F300", kw: 220 },
    { type: "F350", kw: 257 },
    { type: "F425 XTO", kw: 313 },
  ],
  "Mercury Marine": [
    { type: "Verado 200", kw: 147 },
    { type: "Verado 250", kw: 184 },
    { type: "Verado 300", kw: 220 },
    { type: "Verado 400R", kw: 294 },
    { type: "V12 Verado 600", kw: 441 },
  ],
};
